import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Day from './Day';
import StepCollapsed from './StepCollapsed';

const messages = defineMessages({
  sliderDotTitle: {
    id: 'itinerary_day-slider-dot-title',
    defaultMessage: 'Vai alla tappa {idx}',
  },
  esplora_tappe: {
    id: 'itinerary_day_esplora_tappe',
    defaultMessage: 'Esplora le tappe',
  },
  mappa_itinerario: {
    id: 'itinerary_day_mappa_itinerario',
    defaultMessage: 'Mappa itinerario',
  },
  tappa_label: {
    id: 'tappa_label',
    defaultMessage: 'Tappa',
  },
});

const NextArrow = (props) => {
  const intl = useIntl();
  const { className, style, onClick } = props;

  const nextSlide =
    props.currentSlide + 1 === props.slideCount ? 1 : props.currentSlide + 2;
  return (
    <button
      className={className}
      style={{ ...style, display: 'flex' }}
      onClick={onClick}
    >
      <div className="nav-label">
        {intl.formatMessage(messages.tappa_label)} {nextSlide}
      </div>
    </button>
  );
};

function PrevArrow(props) {
  const intl = useIntl();
  const { className, style, onClick } = props;
  const prevSlide =
    props.currentSlide === 0 ? props.slideCount : props.currentSlide;
  return (
    <button
      className={className}
      style={{ ...style, display: 'flex' }}
      onClick={onClick}
    >
      <div className="nav-label">
        {intl.formatMessage(messages.tappa_label)} {prevSlide}
      </div>
    </button>
  );
}

const DayCollapsed = ({ day, ...props }) => {
  const intl = useIntl();
  const slider = React.useRef(null);
  const [activeSlide, setActiveSlide] = React.useState(0);

  const changeSlide = (index) => {
    if (slider?.current?.slickGoTo) slider.current.slickGoTo(index);
    setActiveSlide(index);
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    accessibility: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    afterChange: (index) => {
      setActiveSlide(index); // Update state here
    },

    appendDots: (dots) => (
      <div className="paging">
        <div className="nav-label">
          {intl.formatMessage(messages.esplora_tappe)}
        </div>
        <ul>
          {dots.map((dot, idx) => {
            return (
              <li
                key={idx}
                className={idx === activeSlide ? 'slick-active' : ''}
              >
                <button
                  title={intl.formatMessage(messages.sliderDotTitle, { idx })}
                  onClick={() => changeSlide(idx)}
                >
                  {idx + 1}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    ),
    customPaging: (i) => <span>{i + 1}</span>,
  };
  return (
    <Day day={day} className="day-collapsed" showLeadImage={false}>
      {day?.steps?.length > 0 && (
        <div className="full-width">
          <Slider {...sliderSettings} ref={slider} className="steps">
            {day?.steps?.map((step, index) => {
              return (
                <StepCollapsed
                  step={step}
                  key={`tappa${index}`}
                  stepNumber={index + 1}
                />
              );
            })}
          </Slider>
        </div>
      )}
    </Day>
  );
};
DayCollapsed.propTypes = {
  day: PropTypes.object.isRequired,
};

export default DayCollapsed;
